// Variable to define all route names and their values
// Make sure to define these in ascending tabValue order -- 0 is always first, then 1, etc.
export const routes = {
  biochem: [
    { tabName: "pending", tabValue: 0 },
    { tabName: "hmc", tabValue: 1 },
  ],
  pcr: [
    { tabName: "starletpcr", tabValue: 0 },
    { tabName: "manualpcr", tabValue: 1 },
  ],
};

// Method to handle updating the path
// setValue is the method to update state, history is the history object from useHistory()
export const updatePath = (currentPath, value, pageName, setValue, history) => {
  const tabs = routes[pageName];
  const name = `/${pageName}`;

  if (value !== undefined) {
    tabs.forEach((item) => {
      if (value === item.tabValue) {
        history.push(`${name}/${item.tabName}`);
      }
    });
  } else if (currentPath === name) {
    history.push(`${name}/${tabs[0].tabName}`);
  } else {
    tabs.forEach((item) => {
      if (currentPath === (`${name}/${item.tabName}`)) {
        setValue(item.tabValue);
      }
    });
  }
};

export const updatePathWithTabs = (currentPath, value, pageName, setValue, tabs, history) => {
  const name = `/${pageName}`;

  if (value !== undefined) {
    tabs.forEach((item) => {
      if (value === item.tabValue) {
        history.push(`${name}/${item.route}`);
      }
    });
  } else if (currentPath === name && tabs.length > 0) {
    history.push(`${name}/${tabs[0].route}`);
  } else {
    tabs.forEach((item) => {
      if (currentPath === (`${name}/${item.route}`)) {
        setValue(item.tabValue);
      }
    });
  }
};

/**
 * log: Whether to log current SQL api or not
 * logMigration: Whether to log and make the migration call or not
 * migrated: Does not use in anywhere, only use it to state whether the API is migrated or not
 */
export const endpoints = [
  {
    api: "/generatebatchreports/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/updatewostatus/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/editsample/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/editcustomerinsample/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/getwosbatchreports/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/customerinfo/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/hmcresults/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/gethmc/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/biochemresults/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/chemplatemap/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required (Remove?)
  },
  {
    api: "/chemexcelrules/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/pesticidesdata/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/specialpesticides/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/chem_results/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/chemqueue/",
    log: false,
    logMigration: false,
    migrated: true, // Not Required, frontend won't use this API
  },
  {
    api: "/chemistry_results/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/ssannresults/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/chempp/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/metals_wet_chemistry/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/addchemtest/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/chemdynamicresults/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/fapresults/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/opentronsstatus/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/pendingallergens/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/calculateelisainputs/",
    log: false,
    logMigration: true,
    migrated: false, // Not Required
  },
  {
    api: "/runelisaprotocol/",
    log: false,
    logMigration: true,
    migrated: false, // Not Required
  },
  {
    api: "/generateinlinelabels/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/logger/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/getmanualpcr/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/calculatemanualpcrinputs/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/uploadcountsheets/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/generatecountsheets/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/rechecks/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/getworkorder/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/dynamicsheets/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/dynamicupload/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/dynamicrecheck/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/micro_scanner/",
    log: false,
    logMigration: false,
    migrated: true, // This is a migration API
  },
  {
    api: "/upload_single_count/",
    log: false,
    logMigration: false,
    migrated: true, // This is a migration API
  },
  {
    api: "/hold_micro/",
    log: false,
    logMigration: false,
    migrated: true, // This is a migration API
  },
  {
    api: "/microactions/",
    log: false,
    logMigration: false,
    migrated: true, // // This is a migration API
  },
  {
    api: "/resolve_hierarchy_fail/",
    log: false,
    logMigration: false,
    migrated: true, // This is a migration API
  },
  {
    api: "/notify_tntc/",
    log: false,
    logMigration: false,
    migrated: true, // // This is a migration API
  },
  {
    api: "/migrate_results/",
    log: false,
    logMigration: false,
    migrated: true, // This is a migration API
  },
  {
    api: "/migrate/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/checkduplicates/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/deleteduplicates/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/pathogentests/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/pcrpendingtable/",
    log: false,
    logMigration: false,
    migrated: false,
  },
  {
    api: "/updatepathogendata/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/pcrstatus/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/shelflifewo/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/xmlupload/",
    log: false,
    logMigration: true,
    migrated: false,
  },
  {
    api: "/pcrresults/",
    log: false,
    logMigration: true,
    migrated: false,
  },
  {
    api: "/manualpcr/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/pendingmanualpcr/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/pendingffaperoxide/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/calculateffaperoxideinputs/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/getretestsamples/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/getreports/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/getwodata/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/environment_report/",
    log: false,
    logMigration: false,
    migrated: false, // This is a ESV API
  },
  {
    api: "/product_report/",
    log: false,
    logMigration: false,
    migrated: false, // This is a ESV API
  },
  {
    api: "/sendreports/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/updatereports/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/pendingreports/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/deletereports/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/qcreports/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/getpesticidessamples/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/pesticidemrldata/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/updatepesticidemrldata/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/pesticidescustomercountries/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/updateresultautomation/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/updateshelflifedata/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/shelflifesamples/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/shelflifetests/",
    log: false,
    logMigration: false,
    migrated: true,
  },
  {
    api: "/users/login/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/users/me/",
    log: false,
    logMigration: false,
    migrated: false, // Not Required
  },
  {
    api: "/updatemanualpcr/",
    log: false,
    logMigration: true,
    migrated: true,
  },
  {
    api: "/getexperts/",
    log: false,
    logMigration: false,
    migrated: true, // This is a migration API
  },
];
